/**
 * CORE-1735 — token set of the Live room for the current theme.
 *
 * Slices 1–5b rendered the dark set regardless of the app theme; since slice 6
 * the hook follows ThemeContext (`resolved`). Components never read the app
 * palette directly — every colour comes from `liveTokens[theme]`.
 */
import { Platform } from 'react-native';
import { useTheme } from '../../context/ThemeContext';
import { liveTokens, type LiveTokens } from '../../styles/liveTokens';

/** Slices 1–5b (CORE-1735) rendered dark only; slice 6 (D-59) lets the room follow the app theme. */
export const LIVE_FORCE_DARK = false;

/** Web-only style props (`boxShadow`, `backgroundImage`, …) go behind this. */
export const WEB = Platform.OS === 'web';

export function useLiveTheme(): LiveTokens {
  const { resolved } = useTheme();
  if (LIVE_FORCE_DARK) return liveTokens.dark;
  return resolved === 'dark' ? liveTokens.dark : liveTokens.light;
}
